import { render, staticRenderFns } from "./ReportPageEmptyState.vue?vue&type=template&id=3db2a9e8&scoped=true&"
import script from "./ReportPageEmptyState.vue?vue&type=script&lang=ts&"
export * from "./ReportPageEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPageEmptyState.vue?vue&type=style&index=0&id=3db2a9e8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2a9e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VIcon,VLayout})
